module.exports = __webpack_public_path__ + "static/VerticalImpulseScaling-74107ff54afa11e0146c12b9065f0b8a.png";